/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_Public_SlugInputs */

const cs_settings_profile_public_slug = /** @type {(inputs: Settings_Profile_Public_SlugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veřejný slug`)
};

const en_settings_profile_public_slug = /** @type {(inputs: Settings_Profile_Public_SlugInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public slug`)
};

/**
* | output |
* | --- |
* | "Public slug" |
*
* @param {Settings_Profile_Public_SlugInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_public_slug = /** @type {((inputs?: Settings_Profile_Public_SlugInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_Public_SlugInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_public_slug(inputs)
	return cs_settings_profile_public_slug(inputs)
});